import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { LatLong } from '@root/search/models/map.models';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { DownloadDisclaimer } from '@store/search-board/search-board.actions';
import { Observable } from 'rxjs';
import { Disclaimer } from '@store/search-board/search-board.model';
import { selectDisclaimer } from '@store/search-board/search-board.selector';

@Component({
  selector: 'rlst-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisclaimerModalComponent implements OnInit {
  disclaimer$: Observable<Disclaimer[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LatLong,
    private readonly store$: Store<AppState>,
    public readonly dialogRef: MatDialogRef<DisclaimerModalComponent>
  ) { }

  public ngOnInit(): void {
    this.store$.dispatch(new DownloadDisclaimer(this.data))
    this.disclaimer$ = this.store$.pipe(select(selectDisclaimer, JSON.stringify(this.data)))
  }
}
